import { render } from "./MTextInput.vue?vue&type=template&id=8f8a3004&scoped=true"
import script from "./MTextInput.vue?vue&type=script&lang=js"
export * from "./MTextInput.vue?vue&type=script&lang=js"

import "./MTextInput.vue?vue&type=style&index=0&id=8f8a3004&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f8a3004"]])

export default __exports__